/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {CustomerGroup} from './CustomerGroup';

export interface PickupAddress {
  id?: number;
  header: string;
  customerGroupId: number;
  customerGroup: CustomerGroup;
  createdAt?: Date;
  updatedAt?: Date;
  enabled?: boolean;
  deleted?: boolean;
  pos: number;
}
